export enum TipoAuditoria{
    Added,
    Modified,
    Deleted
}

export type RegistroAuditoria = {
    id: number,
    fecha: string,
    tipoAuditoria: TipoAuditoria,
    nombreUsuario:string,
    nombreTabla:string,
    clavePrimaria:Record<string, string>,
    columnasAfectadas:string[],
    valoresAnteriores:Record<string, string>,
    valoresNuevos:Record<string, string>
}